import { api, type LiveEvent } from '@setplex/tria-api'

import type { Store } from 'effector'
import { genPagesLogic } from '~/shared/effector'

export const $pastEvents: Store<LiveEvent[]> = api.liveEvents.$pastEvents

export const loadMorePastEvents = genPagesLogic(
  api.liveEvents.$pastEventsPageInfo,
  api.liveEvents.loadPastEventsFx
)
